import React, { Component } from 'react';
import './Button.css'
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import Roll from 'react-reveal/Roll';
import Zoom from 'react-reveal/Zoom';
import Flip from 'react-reveal/Flip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import FileSaver from 'file-saver';




export default class AnimatedButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      photoIndex: 0,
      isOpen: false,
    };
  }

  saveFile = () => {

    FileSaver.saveAs(this.props.file, "Wejdi Gharbi Resume.pdf");

  }

  render() {
    const { photoIndex, isOpen } = this.state;
    const { images, douwnload } = this.props
    return (

      <Roll right>
        <Zoom right>
          <Flip right>
            <div>

              <a href="#" className="animated-button1" onClick={() => this.setState({ isOpen: true })} >
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                {this.props.title}
              </a>
              {isOpen && (
                <Lightbox
                  mainSrc={images[photoIndex]}
                  nextSrc={images[(photoIndex + 1) % images.length]}
                  prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                  onCloseRequest={() => this.setState({ isOpen: false })}
                  onMovePrevRequest={() =>
                    this.setState({
                      photoIndex: (photoIndex + images.length - 1) % images.length,
                    })
                  }
                  onMoveNextRequest={() =>
                    this.setState({
                      photoIndex: (photoIndex + 1) % images.length,
                    })
                  }
                   toolbarButtons={douwnload && [<FontAwesomeIcon onClick={this.saveFile} icon={faDownload} size="3x" />]}

                />
              )}
            </div>
          </Flip>
        </Zoom>
      </Roll>

    );
  }
}